function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52302",
  "data-name": "Path 52302",
  d: "M0,0H18.614V18.614H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52303",
  "data-name": "Path 52303",
  d: "M9.98,16.961l-3.1-3.1H4.551A1.551,1.551,0,0,1,3,12.307V4.551A1.551,1.551,0,0,1,4.551,3H15.409a1.551,1.551,0,0,1,1.551,1.551v7.756a1.551,1.551,0,0,1-1.551,1.551H13.083l-3.1,3.1",
  transform: "translate(-0.673 -0.673)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52304",
  "data-name": "Path 52304",
  d: "M14.2,12H8",
  transform: "translate(-1.795 -2.693)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52305",
  "data-name": "Path 52305",
  d: "M8,8h6.2",
  transform: "translate(-1.795 -1.795)",
  fill: "none",
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
});

function SvgMessagesChat15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Messages_Chat.15",
    "data-name": "Messages, Chat.15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.614,
    height: 18.614,
    viewBox: "0 0 18.614 18.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesChat15);
export default __webpack_public_path__ + "static/media/Messages, Chat.15.9f6eaf8e.svg";
export { ForwardRef as ReactComponent };